import http from './client';

export const api = {
  bulkDelete: (payload) => http.post('/bulk-delete', payload),
  dashboard: {
    summary: (params) => http.get('/dashboard', { params }),
  },
  permissions: {
    list: () => http.get('/permissions'),
  },
  users: {
    list: (params) => http.get('/users', { params }),
    create: (payload) => http.post('/users', payload),
    get: (id) => http.get(`/users/${id}`),
    update: (id, payload) => http.put(`/users/${id}`, payload),
    remove: (id) => http.delete(`/users/${id}`),
    forceLogout: (id) => http.post(`/users/${id}/force-logout`),
    impersonate: (id) => http.post(`/users/${id}/impersonate`),
  },
  roles: {
    list: (params) => http.get('/roles', { params }),
    create: (payload) => http.post('/roles', payload),
    get: (id) => http.get(`/roles/${id}`),
    update: (id, payload) => http.put(`/roles/${id}`, payload),
    remove: (id) => http.delete(`/roles/${id}`),
  },
  accounts: {
    coa: () => http.get('/accounts/coa'),
    tree: (params) => http.get('/accounts/tree', { params }),
    list: (params) => http.get('/accounts', { params }),
    create: (payload) => http.post('/accounts', payload),
    get: (id) => http.get(`/accounts/${id}`),
    update: (id, payload) => http.put(`/accounts/${id}`, payload),
    remove: (id) => http.delete(`/accounts/${id}`),
    types: () => http.get('/accounts/types/list'),
    createType: (payload) => http.post('/accounts/types', payload),
    updateType: (id, payload) => http.put(`/accounts/types/${id}`, payload),
    removeType: (id) => http.delete(`/accounts/types/${id}`),
    subTypes: (params) => http.get('/accounts/sub-types/list', { params }),
    createSubType: (payload) => http.post('/accounts/sub-types', payload),
    updateSubType: (id, payload) => http.put(`/accounts/sub-types/${id}`, payload),
    removeSubType: (id) => http.delete(`/accounts/sub-types/${id}`),
    categories: (params) => http.get('/accounts/categories/list', { params }),
    createCategory: (payload) => http.post('/accounts/categories', payload),
    updateCategory: (id, payload) => http.put(`/accounts/categories/${id}`, payload),
    removeCategory: (id) => http.delete(`/accounts/categories/${id}`),
  },
  parties: {
    list: (params) => http.get('/parties', { params }),
    create: (payload) => http.post('/parties', payload),
    get: (id) => http.get(`/parties/${id}`),
    update: (id, payload) => http.put(`/parties/${id}`, payload),
    remove: (id) => http.delete(`/parties/${id}`),
    receivableCategories: () => http.get('/parties/receivable-categories'),
  },
  suppliers: {
    list: (params) => http.get('/suppliers', { params }),
    create: (payload) => http.post('/suppliers', payload),
    get: (id) => http.get(`/suppliers/${id}`),
    update: (id, payload) => http.put(`/suppliers/${id}`, payload),
    remove: (id) => http.delete(`/suppliers/${id}`),
  },
  vouchers: {
    types: () => http.get('/vouchers/types'),
    list: (params) => http.get('/vouchers', { params }),
    create: (payload) => http.post('/vouchers', payload),
    get: (id) => http.get(`/vouchers/${id}`),
    update: (id, payload) => http.put(`/vouchers/${id}`, payload),
    post: (id) => http.post(`/vouchers/${id}/post`),
    void: (id) => http.post(`/vouchers/${id}/void`),
    remove: (id) => http.delete(`/vouchers/${id}`),
    attachment: (id, index) => http.get(`/vouchers/${id}/attachment/${index}`, { responseType: 'blob' }),
  },
  invoices: {
    list: (params) => http.get('/invoices', { params }),
    nextNo: (params) => http.get('/invoices/next-no', { params }),
    create: (payload) => http.post('/invoices', payload),
    get: (id) => http.get(`/invoices/${id}`),
    update: (id, payload) => http.put(`/invoices/${id}`, payload),
    remove: (id) => http.delete(`/invoices/${id}`),
    payments: {
      list: (params) => http.get('/payments', { params }),
      create: (id, payload) => http.post(`/invoices/${id}/payments`, payload),
      remove: (id) => http.delete(`/payments/${id}`),
    },
  },
  debitNotes: {
    list: (params) => http.get('/debit-notes', { params }),
    nextNo: () => http.get('/debit-notes/next-no'),
    create: (payload) => http.post('/debit-notes', payload),
    get: (id) => http.get(`/debit-notes/${id}`),
    update: (id, payload) => http.put(`/debit-notes/${id}`, payload),
    remove: (id) => http.delete(`/debit-notes/${id}`),
  },
  reports: {
    ledger: (params) => http.get('/reports/ledger', { params }),
    accounts: (params) => http.get('/reports/accounts', { params }),
    trialBalance: (params) => http.get('/reports/trial-balance', { params }),
    incomeStatement: (params) => http.get('/reports/income-statement', { params }),
    balanceSheet: (params) => http.get('/reports/balance-sheet', { params }),
    invoices: (params) => http.get('/reports/invoices', { params }),
    payments: (params) => http.get('/reports/payments', { params }),
    vouchers: (params) => http.get('/reports/vouchers', { params }),
    parties: (params) => http.get('/reports/parties', { params }),
    partyStatement: (id, params) => http.get(`/reports/parties/${id}/statement`, { params }),
    employees: (params) => http.get('/reports/employees', { params }),
    payroll: (params) => http.get('/reports/payroll', { params }),
    attendance: (params) => http.get('/reports/attendance', { params }),
    machines: (params) => http.get('/reports/machines', { params }),
    stitches: (params) => http.get('/reports/stitches', { params }),
    gatepasses: (params) => http.get('/reports/gatepasses', { params }),
    inventory: (params) => http.get('/reports/inventory', { params }),
    activityLogs: (params) => http.get('/reports/activity-logs', { params }),
    salesSummary: (params) => http.get('/reports/sales-summary', { params }),
    invoiceSummaryDetails: (params) => http.get('/reports/invoice-summary-details', { params }),
  invoiceSummary: (params) => http.get('/reports/invoice-summary', { params }),
  },
  accountPermissions: {
    list: (params) => http.get('/account-permissions', { params }),
    accounts: (params) => http.get('/account-permissions/accounts', { params }),
    save: (payload) => http.post('/account-permissions', payload),
    bulkSave: (payload) => http.post('/account-permissions/bulk', payload),
    remove: (payload) => http.delete('/account-permissions', { data: payload }),
  },
  shifts: {
    list: (params) => http.get('/shifts', { params }),
    create: (payload) => http.post('/shifts', payload),
    get: (id) => http.get(`/shifts/${id}`),
    update: (id, payload) => http.put(`/shifts/${id}`, payload),
    remove: (id) => http.delete(`/shifts/${id}`),
  },
  departments: {
    list: (params) => http.get('/departments', { params }),
    create: (payload) => http.post('/departments', payload),
    get: (id) => http.get(`/departments/${id}`),
    update: (id, payload) => http.put(`/departments/${id}`, payload),
    remove: (id) => http.delete(`/departments/${id}`),
  },
  employees: {
    list: (params) => http.get('/employees', { params }),
    create: (payload) => http.post('/employees', payload),
    get: (id) => http.get(`/employees/${id}`),
    update: (id, payload) => http.put(`/employees/${id}`, payload),
    remove: (id) => http.delete(`/employees/${id}`),
  },
  machines: {
    list: (params) => http.get('/machines', { params }),
    create: (payload) => http.post('/machines', payload),
    get: (id) => http.get(`/machines/${id}`),
    update: (id, payload) => http.put(`/machines/${id}`, payload),
    remove: (id) => http.delete(`/machines/${id}`),
    assign: (id, payload) => http.post(`/machines/${id}/assign`, payload),
    release: (id, payload) => http.post(`/machines/assignments/${id}/release`, payload),
    articles: (params) => http.get('/machines/articles', { params }),
    loadArticle: (id, payload) => http.post(`/machines/${id}/load-article`, payload),
    releaseArticle: (id, payload) => http.post(`/machines/articles/${id}/release`, payload),
    deleteArticle: (id) => http.delete(`/machines/articles/${id}`),
  },
  stitches: {
    list: (params) => http.get('/stitches', { params }),
    create: (payload) => http.post('/stitches', payload),
    bulk: (payload) => http.post('/stitches/bulk', payload),
    remove: (id) => http.delete(`/stitches/${id}`),
  },
  attendance: {
    list: (params) => http.get('/attendance', { params }),
    summary: (params) => http.get('/attendance/summary', { params }),
    create: (payload) => http.post('/attendance', payload),
    bulk: (payload) => http.post('/attendance/bulk', payload),
    remove: (id) => http.delete(`/attendance/${id}`),
    template: (params) => http.get('/attendance/template', { params, responseType: 'blob' }),
    importCsv: (payload) => http.post('/attendance/import', payload),
  },
  leaves: {
    list: (params) => http.get('/leaves', { params }),
    types: () => http.get('/leaves/types'),
    createType: (payload) => http.post('/leaves/types', payload),
    create: (payload) => http.post('/leaves', payload),
    get: (id) => http.get(`/leaves/${id}`),
    update: (id, payload) => http.put(`/leaves/${id}`, payload),
    approve: (id) => http.post(`/leaves/${id}/approve`),
    reject: (id) => http.post(`/leaves/${id}/reject`),
    remove: (id) => http.delete(`/leaves/${id}`),
  },
  payroll: {
    list: (params) => http.get('/payroll', { params }),
    get: (id) => http.get(`/payroll/${id}`),
    summary: (params) => http.get('/payroll/summary', { params }),
    preview: (payload) => http.post('/payroll/preview', payload),
    generate: (payload) => http.post('/payroll/generate', payload),
    approve: (id) => http.post(`/payroll/${id}/approve`),
    process: (id, payload) => http.post(`/payroll/${id}/process`, payload),
  },
  advances: {
    list: (params) => http.get('/advances', { params }),
    create: (payload) => http.post('/advances', payload),
    get: (id) => http.get(`/advances/${id}`),
    remove: (id) => http.delete(`/advances/${id}`),
  },
  gatepasses: {
    list: (params) => http.get('/gatepasses', { params }),
    nextNo: (params) => http.get('/gatepasses/next-no', { params }),
    articles: (params) => http.get('/gatepasses/articles', { params }),
    create: (payload) => http.post('/gatepasses', payload),
    get: (id) => http.get(`/gatepasses/${id}`),
    update: (id, payload) => http.put(`/gatepasses/${id}`, payload),
    remove: (id) => http.delete(`/gatepasses/${id}`),
  },
  inventory: {
    units: () => http.get('/inventory/units'),
    getUnit: (id) => http.get(`/inventory/units/${id}`),
    createUnit: (payload) => http.post('/inventory/units', payload),
    updateUnit: (id, payload) => http.put(`/inventory/units/${id}`, payload),
    deleteUnit: (id) => http.delete(`/inventory/units/${id}`),
    items: (params) => http.get('/inventory/items', { params }),
    createItem: (payload) => http.post('/inventory/items', payload),
    getItem: (id) => http.get(`/inventory/items/${id}`),
    updateItem: (id, payload) => http.put(`/inventory/items/${id}`, payload),
    deleteItem: (id) => http.delete(`/inventory/items/${id}`),
    stock: (params) => http.get('/inventory/stock', { params }),
    movements: (params) => http.get('/inventory/movements', { params }),
    variance: (params) => http.get('/inventory/variance-report', { params }),
    adjust: (payload) => http.post('/inventory/adjust', payload),
  },
  settings: {
    get: () => http.get('/settings'),
    update: (payload) => http.put('/settings', payload),
  },
  activityLogs: {
    list: (params) => http.get('/activity-logs', { params }),
    get: (id) => http.get(`/activity-logs/${id}`),
    remove: (id) => http.delete(`/activity-logs/${id}`),
  },
};

export default api;
